<template>
    <v-dialog v-model="shows" width="480">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card>
            <v-card-title>세션정보</v-card-title>
            <vertical-form-table
                v-bind="{
                    value,
                    items,
                }"
                mode="view"
            />
        </v-card>
    </v-dialog>
</template>

<script>
import verticalFormTable from "./vertical-form-table.vue";
const initForm = (form = {}) => ({
    ...(form || {}),
    meta: {
        ...(form?.meta || {}),

        ua: form?.meta?.ua || null,

        browser: {
            ...(form?.meta?.browser || {}),
            name: form?.meta?.browser?.name || null,
            version: form?.meta?.browser?.version || null,
            major: form?.meta?.browser?.major || null,
        },

        cpu: {
            ...(form?.meta?.cpu || {}),
            architecture: form?.meta?.cpu?.architecture || null,
        },

        device: {
            ...(form?.meta?.device || {}),
            model: form?.meta?.device?.model || null,
            type: form?.meta?.device?.type || null,
            vendor: form?.meta?.device?.vendor || null,
        },

        engine: {
            ...(form?.meta?.engine || {}),
            name: form?.meta?.engine?.name || null,
            version: form?.meta?.engine?.version || null,
        },

        os: {
            ...(form?.meta?.os || {}),
            name: form?.meta?.os?.name || null,
            version: form?.meta?.os?.version || null,
        },
    },
});

export default {
    components: { verticalFormTable },
    props: {
        value: { type: Object, default: initForm },
    },
    data: () => ({
        shows: false,
    }),
    computed: {
        items() {
            return [
                {
                    key: "ip",
                    term: "IP",
                    type: "text",
                },
                {
                    key: "meta.os",
                    term: "OS",
                    formatter: ({ name, version } = {}) => [name, version].filter((item) => item).join(" ") || "-",
                },
                {
                    key: "meta.browser",
                    term: "브라우저",
                    formatter: ({ name, version } = {}) => [name, version].filter((item) => item).join(" ") || "-",
                },
                {
                    key: "meta.engine",
                    term: "엔진",
                    formatter: ({ name, version } = {}) => [name, version].filter((item) => item).join(" ") || "-",
                },
                {
                    key: "meta.device",
                    term: "기기",
                    formatter: ({ model, type, vendor } = {}) => [model, type, vendor].filter((item) => item).join(" / ") || "-",
                },
                {
                    key: "meta.cpu",
                    term: "CPU",
                    formatter: ({ architecture } = {}) => [architecture].filter((item) => item).join(" / ") || "-",
                },
            ];
        },
    },
};
</script>

<style></style>
